import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { TargetsBaseDataProvider } from './TargetsBaseDataProvider';
import { ConsoleRequestSettings, GetNodeChildrenRequest, GetNodeChildrenResponse, GetRootRequest, Node } from '../type';
import { ProtectedEntitiesSVE, ProtectedEntitiesContainers } from '@nirvana/shared/constants';
import { DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS } from '../type/TargetSettings';

export class SVEDataProvider extends TargetsBaseDataProvider {
  public async getRootNode(payload: GetRootRequest, settings: ConsoleRequestSettings): Promise<Node> {
    try {
      const endpoint = settings.SVE?.rootNode?.endpoint ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.SVE.rootNode.endpoint;
      const method = settings.SVE?.rootNode?.method ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.SVE.rootNode.method;

      return await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.SVE,
        endpoint: endpoint,
        method: method,
        payload: payload,
      });
    } catch (e) {
      throw new Error(e);
    }
  }

  public async getChildNodes(
    payload: GetNodeChildrenRequest,
    settings: ConsoleRequestSettings
  ): Promise<GetNodeChildrenResponse> {
    try {
      const endpoint =
        settings.SVE?.childNodes?.endpoint ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.SVE.childNodes.endpoint;
      const method = settings.SVE?.childNodes?.method ?? DEFAULT_DATAPROVIDER_CONSOLE_REQUESTS.SVE.childNodes.method;

      return await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.SVE,
        endpoint: endpoint,
        method: method,
        payload: payload,
      });
    } catch (e) {
      throw new Error(e);
    }
  }

  public getViewType(type: number): number {
    switch (type) {
      case ProtectedEntitiesSVE.ROOT:
      case ProtectedEntitiesSVE.VMWARE_COLLECTION:
      case ProtectedEntitiesSVE.XEN_COLLECTION:
      case ProtectedEntitiesSVE.NUTANIX_COLLECTION:
      case ProtectedEntitiesSVE.AMAZON_EC2_COLLECTION:
      case ProtectedEntitiesSVE.AZURE_COLLECTION:
      case ProtectedEntitiesContainers.TYPE_COLLECTION:
        return ProtectedEntitiesSVE.viewType.SVE_ROOT;

      case ProtectedEntitiesSVE.VMWARE_CENTER:
      case ProtectedEntitiesSVE.VMWARE_COMPUTE_RESOURCE:
      case ProtectedEntitiesSVE.VMWARE_CLUSTER_COMPUTE_RESOURCE:
      case ProtectedEntitiesSVE.VMWARE_DATACENTER:
      case ProtectedEntitiesSVE.VMWARE_DATASTORE:
      case ProtectedEntitiesSVE.VMWARE_FOLDER:
      case ProtectedEntitiesSVE.VMWARE_HOST_SYSTEM:
      case ProtectedEntitiesSVE.VMWARE_RESOURCE_POOL:
      case ProtectedEntitiesSVE.VMWARE_STORAGE_POD:
      case ProtectedEntitiesSVE.VMWARE_VIRTUAL_APP:
      case ProtectedEntitiesSVE.VMWARE_VIRTUAL_MACHINE:
        return ProtectedEntitiesSVE.viewType.vmware.HOSTS_AND_CLUSTERS;

      case ProtectedEntitiesSVE.XEN_SERVER:
      case ProtectedEntitiesSVE.XEN_FOLDER:
      case ProtectedEntitiesSVE.XEN_HOST:
      case ProtectedEntitiesSVE.XEN_POOL:
      case ProtectedEntitiesSVE.XEN_VIRTUAL_MACHINE:
        return ProtectedEntitiesSVE.viewType.xen.SERVER;

      case ProtectedEntitiesSVE.NUTANIX_SERVER:
      case ProtectedEntitiesSVE.NUTANIX_CLUSTER:
      case ProtectedEntitiesSVE.NUTANIX_HOST:
      case ProtectedEntitiesSVE.NUTANIX_VIRTUAL_MACHINE:
        return ProtectedEntitiesSVE.viewType.SVE_NUTANIX;

      case ProtectedEntitiesSVE.AMAZON_EC2_SERVER:
      case ProtectedEntitiesSVE.AMAZON_EC2_REGION:
      case ProtectedEntitiesSVE.AMAZON_EC2_AZ:
      case ProtectedEntitiesSVE.AMAZON_EC2_INSTANCE:
        return ProtectedEntitiesSVE.viewType.SVE_AMAZON_EC2;

      case ProtectedEntitiesSVE.AZURE_SERVER:
      case ProtectedEntitiesSVE.AZURE_REGION:
      case ProtectedEntitiesSVE.AZURE_AVAILABILITY_ZONE:
      case ProtectedEntitiesSVE.AZURE_VIRTUAL_MACHINE:
        return ProtectedEntitiesSVE.viewType.SVE_AZURE;

      case ProtectedEntitiesContainers.TYPE_CUSTOM_GROUPS:
      case ProtectedEntitiesContainers.TYPE_FOLDER:
      case ProtectedEntitiesContainers.TYPE_HOST:
        return ProtectedEntitiesSVE.viewType.SVE_CONTAINERS;

      default:
        return ProtectedEntitiesSVE.viewType.SVE_CUSTOM_GROUPS;
    }
  }

  public isLeafNode(node: Node, userMode: boolean, showOnlyCompanies: boolean, rootNodeId: string): boolean {
    if (userMode) {
      return [
        ProtectedEntitiesSVE.VMWARE_CENTER,
        ProtectedEntitiesSVE.XEN_SERVER,
        ProtectedEntitiesSVE.NUTANIX_SERVER,
        ProtectedEntitiesSVE.AMAZON_EC2_SERVER,
        ProtectedEntitiesSVE.AZURE_SERVER,
        ProtectedEntitiesContainers.TYPE_CUSTOM_GROUPS,
      ].includes(node.type);
    }
    return false;
  }
}
